<template>
  <div>
      <div class="center text-center">
          <p class="display-1">Page Not Found</p>
          <v-btn color="" @click="$router.push('/locations')" >Home</v-btn>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
    .center {
        position: absolute;
        top: 35%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>
